module.exports = __webpack_public_path__ + "img/recognizing.33bbc4c6.gif";